import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VonConfirmationModule } from '@von-development-studio/primeng-confirmation-dialog';
import { VonPrimengFormModule } from '@von-development-studio/primeng-form-validation';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { CookieService } from 'ngx-cookie-service';
import { ConsultDiagnosticItemComponent } from './component/consult-diagnostic/consult-diagnostic-item.component';
import { ConsultPatientComponent } from './component/consult-patient/consult-patient.component';
import { KhuyanaHeaderModule } from './component/header/khuyana-header.module';
import { PdfViewerComponent } from './component/pdf-viewer/pdf-viewer.component';
import { StringSplitComponent } from './component/string-split/string-split.component';
import { TablePagedFooterComponent } from './component/table-paged-footer/table-paged-footer.component';
import { DevExtremeModule } from './dev-extreme.module';
import { PrimeNgModule } from './prime-ng.module';
import { RestInterceptorService } from './service/rest-interceptor.service';

const MODULES: any[] = [
  HttpClientModule,
  BrowserModule,
  BrowserAnimationsModule,
  PrimeNgModule,
  VonPrimengFormModule,
  VonConfirmationModule,
  DevExtremeModule,
  KhuyanaHeaderModule,
];

const COMPONENTS: any[] = [
  PdfViewerComponent,
  StringSplitComponent,
  TablePagedFooterComponent,
  ConsultPatientComponent,
  ConsultDiagnosticItemComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...MODULES, ...COMPONENTS],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RestInterceptorService,
      multi: true,
    },
    CookieService,
    VonMessageService,
  ],
})
export class CoreModule {}
